import Vue from 'vue'
import App from './App.vue'
import { router } from './_helpers'
import store from './store/index'
import Buefy from 'buefy'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import en from './lang/en'
import jp from './lang/jp'
import './assets/sass/main.scss'
// setup fake backend
import { configureFetchApi } from '@/_helpers'
import { localStore } from '@/_utils/localstore'
configureFetchApi()

import './registerServiceWorker'

import _ from 'lodash'
Object.defineProperty(Vue.prototype, '$_', { value: _ })

Vue.use(Buefy)
Vue.use(VueI18n)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'vvFields',
})

Vue.config.productionTip = false

const messages = {
  'en': en,
  'jp': jp,
}

const i18n = new VueI18n({
  locale: localStore.getItem('lang') || 'en',
  fallbackLocale: 'en',
  messages,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
